omadapp.singletons.gamesParser =new(function() {
    var t = this;
    var $ = jQuery
    t.parsear = parsear
    
    function parsear (conf) {
    	trace ("omadapp.singletons.gameparser::parsear "+conf)
    	if (!omada.estaticos.gameparser[conf]) {
    		trace ("no existe la configuración "+conf+".\nSe ejecutarán por defecto")
    		return
    	}
    	patchObject(omada.estaticos.gameparser[conf],omada.games)
    }

    function patchObject (patch,topatch) {
    	for (var n in patch) {
    		var res = buscar (topatch,n)
    		if (typeof(patch[n])==="object") {
    			patchObject (patch[n],res)
    		} else {
    			for (var i = 0; i < res.length; i++) {
    				res[i][n] = patch[n]
    			}
    		}
    	}

    }

    function buscar (obj,query,indent) {
    	var res = []
    	indent = indent+1 || 1

    	var lst = query.split(".")
    	var  ahora = lst.shift()
    	rest =lst.join(".")
    	var prop = ahora
    	var val = null
    	if (ahora.indexOf("=")>-1) {
    		prop = ahora.split("=")[0]
    		val = ahora.split("=")[1]
    	}

    	for (var n in obj) {
    		if (n==prop) {
    			if (val == null) {
    				// directo
    				if (rest=="") {
						//console.log ("ENCONTRADO!!!\n",n,obj[n])
						res.push (obj)
    				} else {
    					if (typeof(obj[n])==="object") {
    						add(buscar (obj[n],rest,indent))
    					}
    				}
    			} else if (obj[n]==val) {
    				//condicion
    				if (rest=="") {
    					//console.log ("ENCONTRADO!!!\n",n,obj[n])
    					res.push (obj)
    				} else {
    					if (typeof(obj[n])==="object") {
    						add(buscar (obj[n],rest,indent))
    					}
    				}
    			}
    		} else if ( typeof(obj[n])==="object") {
    			add(buscar (obj[n],query,indent))

    		}
    	}
    	function add (arr) {
    		for (var i = 0; i < arr.length; i++) {
    			res.push(arr[i])
    		}
    	}
    	return res
    }
})